import { AddressDefaultType } from '@/components/_common/AddressModal/types';
import { PageRequest } from '@/core/request/PageRequest';
import { ContactDetailList } from '../_shared/Contact';

export enum SupplierClassification {
  Dealership = 'DEALERSHIP',
  Distributor = 'DISTRIBUTOR',
  Retail = 'RETAIL',
  Wholesale = 'WHOLESALE',
  Others = 'OTHERS',
}

export enum SupplierType {
  Individual = 'INDIVIDUAL',
  LegalPerson = 'LEGAL_PERSON',
}

export enum ContactTypeEnum {
  email = 'EMAIL',
  mobile = 'MOBILE',
  fax = 'FAX',
  phone = 'PHONE',
  whatsapp = 'WHATSAPP',
}

export enum SupplierTypeCredit {
  credit = 'CREDIT',
  debit = 'DEBIT',
}

export enum SupplierOrderColumn {
  COMPANY_NAME = 'COMPANY_NAME',
  PURCHASE_CODE = 'PURCHASE_CODE',
  PURCHASE_ITEM_NAME = 'PURCHASE_ITEM_NAME',
  QUANTITY = 'QUANTITY',
  INVOICE_KEY = 'INVOICE_KEY',
  VALUE = 'VALUE',
}

export enum SupplierColumn {
  companyName = 'companyName',
  purchaseCode = 'purchaseCode',
  purchaseItemName = 'purchaseItemName',
  quantity = 'quantity',
  invoiceKey = 'invoiceKey',
  value = 'value',
}

export interface ContactList {
  birthDate: string;
  department: string;
  detailList: ContactDetailList[];
  gender: string;
  id: number;
  name: string;
  supplierId: number;
}

export interface Supplier {
  id: number;
  planAccountId: number;
  active: boolean;
  address: AddressDefaultType;
  contactList: ContactList[];
  classification: SupplierClassification;
  cnpj: string;
  cpf: string;
  email: string;
  matrixId?: number;
  municipalRegistration: string;
  name: string;
  nickName: string;
  note: string;
  product: string;
  stateRegistration: string;
  type: SupplierType;
  webSite: string;
  credit: number;
  fantasyName?: string;
  michelinSegmentCode?: string;
}

export interface SupplierReduced {
  cnpj: string;
  cpf: string;
  email: string;
  id: number;
  name: string;
  planAccountId?: number;
  fantasyName?: string;
  isPhoneWhatsAppContact?: boolean;
  phone: string;
  matrixId?: number;
}

export interface ListSuppliersQuery extends PageRequest {
  active?: boolean;
  cpfCnpj?: string;
  matrixId?: number;
  name?: string;
  nickName?: string;
  planAccountId?: number;
  product?: string;
  search?: string;
  showGlobal?: boolean;
}

export interface ListCreditsSupplierQuery extends PageRequest {
  search?: string;
  supplierCreditType?: SupplierTypeCredit;
  supplierId?: number;
  orderByColumn?: SupplierOrderColumn;
}

export interface SupplierCredits {
  accountPayableCode: number;
  companyName: string;
  createdAt: string;
  id: number;
  installmentPayableCode: string;
  installmentPayableId: number;
  isChargeback: boolean;
  isReturnCancellation: boolean;
  purchaseCode: number;
  purchaseDocument: string;
  purchaseId: number;
  type: SupplierTypeCredit;
  value: number;
}
